import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
  render() {
    return (
      <div className="Header">
        <header className="Header-header">
          <h1>Fullstack Javascript Developer</h1>
        </header>
        
      </div>
    );
  }
}

export default Header;





// WEBPACK FOOTER //
// ./src/components/Header.js